import { forwardRef } from 'react';

import type { IconProps } from './types';

const Quotes = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <path
      d="M598.535 917.993l-28.845-47.594c163.457-86.535 245.183-168.263 245.183-245.183 0-32.691-30.767-64.901-92.305-96.631-54.806-28.845-93.026-57.69-114.659-86.535s-32.451-66.343-32.451-112.496c0-61.536 21.874-114.178 65.622-157.927s95.91-65.622 156.485-65.622c67.306 0 121.87 26.922 163.696 80.766s62.738 124.033 62.738 210.569c0 142.303-53.844 264.413-161.532 366.332-36.537 33.652-72.353 60.815-107.448 81.487s-87.256 44.95-156.485 72.834zm-569.689 0L.001 870.399c163.457-87.497 245.183-169.224 245.183-245.183 0-18.268-6.731-34.373-20.192-48.315s-37.499-30.047-72.113-48.315c-52.883-26.923-90.621-55.527-113.217-85.814S5.769 374.746 5.769 329.555c0-62.498 21.633-115.38 64.901-158.648s95.189-64.901 155.764-64.901c68.267 0 123.312 26.922 165.138 80.766s62.738 124.033 62.738 210.569c0 68.267-13.702 133.648-41.104 196.147s-68.026 119.226-121.87 170.186c-62.498 57.691-149.994 109.13-262.49 154.321z"
      fill={color}
    />
  </svg>
));

export default Quotes;
